import { XYCoord } from 'react-dnd';
import type { RowItem } from './types';

export const mapToFormModel = <R extends RowItem>(items: R[], idKey: string): (R & { index: number })[] => {
    return items.map((item, index) => ({
        ...item,
        index,
        id: item[idKey],
        name: item.name,
        isDraggable: item.isDraggable ?? true,
    }));
};

interface GetItemStylesOptions {
    initialOffset: Nullable<XYCoord>;
    currentOffset: Nullable<XYCoord>;
    defaultTranslateX?: number;
    defaultTranslateY?: number;
}

export const getRowStyles = (options: GetItemStylesOptions) => {
    const { initialOffset, currentOffset, defaultTranslateX = 0, defaultTranslateY = 0 } = options;

    if (!initialOffset || !currentOffset) {
        return { display: 'none' };
    }

    const { x, y } = currentOffset;
    const transform = `translate(${x - defaultTranslateX}px, ${y - defaultTranslateY}px)`;

    return {
        transform,
        WebkitTransform: transform,
    };
};

export const combineFieldNames = (...args: (string | number)[]) => args.join('.');
